export const number_state_by_country_id = (country_id) => {
  if (country_id == 51) return "+372";
  else if (country_id == 115) return "+371";
  else if (country_id == 122) return "+370";
  return "?";
};

export const console_error = (string) => {
  console.error("Error: ", string);
};

export const log = (string) => console.log(string);

export const handleKeyDown = (e, func) => {
  if (e.key == "Enter") {
    return func();
  }
};


export const handleKeyDown2 = (func) => (e) => {
  if (e.key == "Enter") {
    return func();
  }
};

export const onChangeUseState = (setState) => (e) => {
  const { name, value } = e.target;
  return setState((prev) => ({
    ...prev,
    [name]: value,
  }));
};

export const markedFiltering = (old_data, new_data) => {
  return [...new Set(old_data.filter((pr) => !new_data.includes(pr)))];
};

export const markedFilteringUnit = (old_data, new_id) => {
  const check = old_data.includes(new_id);
  if (check) {
    return old_data.filter((d) => d !== new_id);
  }
  return [...new Set([...old_data, new_id])];
};
